import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { CrossSellLightBoxHeader } from './cross_sell_light_box_header';
import { CrossSellLightBoxContent } from './cross_sell_light_box_content';

function CrossSellLightBox(props) {
    const title = props.data ? props.data.title : '';
    const additionalClassNames = ['cross-sell-light-box__lightbox'];
    if (props.data && props.data.fromEuLabels) {
        additionalClassNames.push('eu-labels-light-box__lightbox');
    }
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={additionalClassNames}
            headerIcon="icon--wheel-alignment"

        >
            <div className="cross-sell-light-box">
                <CrossSellLightBoxHeader title={title} />
                <CrossSellLightBoxContent
                    data={props.data}
                    expanded={props.expanded}
                    LightBoxVisible={props.LightBoxVisible}
                    error={props.error}
                    onExpand={props.onExpand}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

CrossSellLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { CrossSellLightBox };
